//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    desktopPicture: {
      type: Object,
      required: false
    },
    mobPicture: {
      type: Object,
      required: false
    },
    alt: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    pictureUrl (url) {
      return this.$absoluteImageUrl(url)
    },
  }
}
